export const ManagePaymentFlow = {
  Add: 'Add',
  Remove: 'Remove',
  Edit: 'Edit',
} as const;

export type ManagePaymentFlow = keyof typeof ManagePaymentFlow;
